/* ============================================================
   Ibn Arabi · Page scripts
   ------------------------------------------------------------
   - Injects the Ibn Arabi logo next to the HayaStyle logo
     in the live theme's header (only on .ia-page).
   - PDP variant picker (vials → form id, price, buy button).
   Idempotent — safe to load from multiple sections.
   ============================================================ */

(function() {
  if (window.__IA_LOADED__) return;
  window.__IA_LOADED__ = true;

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();

  function init() {
    var root = document.querySelector('.ia-page');
    if (!root) return;

    injectCobrand();

    if (document.querySelector('.ia-pdp__form')) {
      setupVariantPicker();
    }
  }

  /* ============ DUAL-LOGO INJECTION ============ */
  function injectCobrand() {
    var headerLogo = document.querySelector('#header-group .header-logo');
    if (!headerLogo) return;
    if (headerLogo.querySelector('.ia-cobrand')) return; // already injected

    var logoUrl = window.IA_LOGO_URL || '/cdn/shop/files/ibn-arabi-logo.svg';

    var cobrand = document.createElement('span');
    cobrand.className = 'ia-cobrand';
    cobrand.setAttribute('aria-label', 'Ibn Arabi');

    var sep = document.createElement('span');
    sep.className = 'ia-cobrand__sep';
    sep.setAttribute('aria-hidden', 'true');

    var img = document.createElement('img');
    img.className = 'ia-cobrand__logo';
    img.src = logoUrl;
    img.alt = 'Ibn Arabi · The Fragrance House';
    img.loading = 'eager';

    cobrand.appendChild(sep);
    cobrand.appendChild(img);
    headerLogo.appendChild(cobrand);
  }

  /* ============ PDP VARIANT PICKER ============ */
  function setupVariantPicker() {
    var data = window.IbnArabiPdpData;
    if (!data) return;

    var variants = data.variants || [];
    var optionNames = data.optionNames || [];
    var moneyFormat = data.moneyFormat || '₹ {{amount}}';

    var root = document.querySelector('.ia-page');
    var idInput = root.querySelector('.ia-pdp__form input[name="id"]');
    var priceEl = root.querySelector('.ia-pdp__price');
    var buyBtn = root.querySelector('.ia-pdp__buy');

    function formatMoney(cents) {
      var amount = (cents / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      var clean = moneyFormat.replace(/<[^>]+>/g, '');
      return clean
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 }));
    }

    function findVariant() {
      var picked = {};
      root.querySelectorAll('.ia-pdp__form input[type=radio]:checked').forEach(function(r) {
        var m = r.name.match(/options\[(.+)\]/);
        if (m) picked[m[1]] = r.value;
      });
      return variants.find(function(v) {
        return optionNames.every(function(name, i) {
          return v['option' + (i + 1)] === picked[name];
        });
      });
    }

    function updateVariant() {
      var v = findVariant();
      if (!v) return;
      if (idInput) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        buyBtn.textContent = v.available ? ('Take it home · ' + formatMoney(v.price)) : 'Currently unavailable';
      }
    }

    root.querySelectorAll('.ia-pdp__vial').forEach(function(v) {
      v.addEventListener('click', function(e) {
        e.preventDefault();
        var input = v.querySelector('input');
        if (!input) return;
        root.querySelectorAll('input[name="' + input.name + '"]').forEach(function(x) {
          x.checked = false;
          x.closest('label').classList.remove('on');
        });
        input.checked = true;
        v.classList.add('on');
        var container = v.closest('.ia-pdp__vials');
        if (container) {
          var fieldLabel = container.previousElementSibling;
          if (fieldLabel && fieldLabel.classList.contains('ia-pdp__field-label')) {
            var pick = fieldLabel.querySelector('.pick');
            if (pick) pick.textContent = input.value;
          }
        }
        updateVariant();
      });
    });
  }
})();
